<template>
    <b-modal
        :title="'Stone certificates'"
        :visible="value"
        size="lg"
        @shown="getCertificates"
        no-close-on-backdrop
        @close="closeModal"
    >
        <!-- Custom Header -->
        <template v-slot:modal-header>
            <div class="d-flex justify-content-between align-items-center w-100">
                <h5 class="modal-title m-0">{{ $t("Stone certificates") }}</h5>
                <b-button
                    size="sm"
                    variant="primary"
                    @click="showDialog = true"
                    class="btn-round"
                >
                    <font-awesome-icon :icon="['fas', 'plus']" />
                    {{ $t("Add Certificate") }}
                </b-button>
            </div>

            <button type="button" aria-label="Close" class="close" @click="closeModal">×</button>
        </template>

        <!-- Loading Spinner -->
        <loading-spinner class="loading-spinner" v-if="loading" />

        <!-- Table -->
        <b-table
            v-else
            class="smartvault-variants-list"
            small
            striped
            hover
            :items="data"
            :fields="fields"
        >
            <template v-slot:cell(image)>
                <file-items
                    v-if="data.item.files.length"
                    :files="data.item.files"
                ></file-items>
            </template>
            <template v-slot:cell(controls)>
                <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="showEditDialog(data.item)"
                >
                    {{ $t("edit") }}
                </b-button>
                <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="showDeleteDialog(data.item)"
                >
                    {{ $t("delete") }}
                </b-button>
            </template>
        </b-table>

        <!-- Footer -->
        <template v-slot:modal-footer>
            <b-button size="md" @click="closeModal"> Close </b-button>
        </template>

        <!-- Certificate Form Dialog -->
        <certificate-form-dialog
            v-if="showDialog"
            :serial-number="serialNumber"
            :certificate="certificate"
            :files="files_preview"
            :id="id"
            @certificate-added="certificateAdded"
            @certificate-updated="certificateUpdated"
            v-model="showDialog"
            @close="closeCertificateModal"
        >
        </certificate-form-dialog>
    </b-modal>
</template>


<script>
import axios from "axios";
import CertificateFormDialog from "../EditDialogs/CertificateFormDialog";
import FileItems from "../Product/FileItems";
import LoadingSpinner from "../../Common/LoadingSpinner";

export default {
  name: "CertificateDialog",
  components: { CertificateFormDialog, FileItems, LoadingSpinner },
  props: {
    serialNumber: Object,
    value: Boolean
  },
  data() {
    return {
      data: [],
      id: null,
      certificate: null,
      loading: true,
      showDialog: false,
      files_preview: [],
      fields: [
        {
          key: "certificate_id",
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "image",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "created_at",
          label: this.$t("date"),
          sortable: true
        },
        {
          key: "controls",
          sortable: false
        }
      ]
    };
  },
  methods: {
    certificateAdded(certificate) {
      if (Array.isArray(this.data)) {
        this.data.unshift(certificate); // Ajoute au début sans écraser
      } else {
        this.data = [certificate]; // Crée un nouveau tableau si nécessaire
      }

      this.showDialog = false;
      this.certificate = null;
      this.id = null;
      this.files_preview = [];
      this.$emit("certificate-added");
    },

    certificateUpdated(certificate) {
      this.loading = true;

      this.getCertificates();

      this.showDialog = false;
      this.certificate = null;
      this.id = null;
      this.files_preview = [];

      this.$emit("certificate-added");
    },
    closeModal() {
      this.$emit("close");
    },
    closeCertificateModal() {
      this.showDialog = false;
    },
    showEditDialog(item) {
      this.files_preview = item.files;
      this.certificate = item.certificate_id;
      this.id = item.id;
      this.showDialog = true;
    },
    showDeleteDialog(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to delete certificate?", {
          title: this.title,
          okVariant: "danger",
          okTitle: this.$t("delete"),
          footerClass: "p-2",
          hideHeaderClose: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.deleteCertificate(item);
          }
        });
    },
    deleteCertificate(certificate) {
      let idToDelete = certificate.id;
      this.loading = true;
      axios
        .delete(
          "/api/instances/" +
            this.serialNumber.id +
            "/stone-certificates/" +
            certificate.id
        )
        .then(response => {
          this.data = this.data.filter(item => {
            return item.id !== idToDelete;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCertificates() {
      axios
        .get("/api/instances/" + this.serialNumber.id + "/stone-certificates")
        .then(response => {
          this.data = response.data.data;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>
